import * as React from 'react';

export interface FieldBaseContextValues {
    setFocused: React.Dispatch<React.SetStateAction<boolean>> | null;
    setFilled: React.Dispatch<React.SetStateAction<boolean>> | null;
    controlRef:
        | ((element: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement | HTMLButtonElement | null) => void)
        | null;
}

export const FieldBaseContext = React.createContext<FieldBaseContextValues>({
    setFocused: null,
    setFilled: null,
    controlRef: null,
});

export function useFieldBase(): FieldBaseContextValues {
    return React.useContext(FieldBaseContext);
}
